import { gettext } from '@eventbrite/i18n';
import { CTA_CHECKOUT_TEXT } from '../../../constants';
import { getTotalCost } from '../../../containers/ticketSelection/utils/getTotalCost';
import { Ticket, TicketId } from '../../../models/tickets';

export const getCtaTextIncludingTotalCost = ({
    areTicketsSelected,
    isFreeEvent,
    selectedTickets,
    totalCostDisplay,
}: {
    areTicketsSelected: boolean;
    isFreeEvent: boolean;
    selectedTickets: Record<TicketId, Ticket>;
    totalCostDisplay: string;
}) => {
    if (isFreeEvent) {
        return gettext('Reserve a spot');
    }

    if (!areTicketsSelected) {
        return CTA_CHECKOUT_TEXT.toString();
    }

    const areOnlyFreeTicketsSelected = getTotalCost(selectedTickets) === 0;

    return areOnlyFreeTicketsSelected
        ? gettext('Reserve a spot')
        : gettext('Check out for %(price)s', {
              price: totalCostDisplay,
          });
};
